// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tBaos","content":"styles_content__1y8ut","tableWrap":"styles_tableWrap__3U2uE"};